import React,{useState,useEffect} from 'react'
import TabContent from '../../TabContent'
import TabNavItem from '../../TabNavItem'
import AllDocs from './AllDocs'
import AddEditDoctorInfo from './AddEditDoctorInfo'
import AddDoctorInfo from './AddDoctorInfo'
import AddBookingType from './AddBookingType'

function BookingTab() {
  const [activeTab,setActiveTab] = useState('booking')
  return (
    <>
      <div>
        <nav className="nav nav-tabs me-3" style={{width:'100%'}}>
            <TabNavItem
              id="booking"
              title='Booking'
              icon='bi bi-person-badge'
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
             <TabNavItem
              id="bookingType"
              title='Appointment Types'
              icon='bi bi-calendar'
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
             <TabNavItem
              id="bookingAddDoctor"
              title='Add Doctor'
              icon='bi bi-person-plus'
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
        </nav>
        <div className="tab-content pt-2">
          <TabContent id="booking" activeTab={activeTab}>
              <div className="p-3">
               <AllDocs/>
              </div>
          </TabContent>
          <TabContent id="bookingType" activeTab={activeTab}>
            <AddBookingType/>
          </TabContent>
          <TabContent id="bookingAddDoctor" activeTab={activeTab}>
              <AddDoctorInfo/>
          </TabContent>
        </div>
      </div>
    </>
      )
}

export default BookingTab